import * as React from 'react';
import { Button, type ButtonProps } from '@/components/ui/button';
import { PublishIcon } from '@/components/shared/icons/mss-publish-icon';
import { cn } from '@/lib/utils';

interface MssPublishButtonProps extends Omit<ButtonProps, 'children'> {
  label?: string;
}

export function MssPublishButton({
  label = 'Publish',
  className,
  ...props
}: MssPublishButtonProps) {
  return (
    <Button data-test-id="btn-header-publish" variant="outline" className={cn('gap-2', className)} {...props}>
      <PublishIcon className="h-5 w-5" />
      {label}
    </Button>
  );
}
